<style lang="scss" scoped>
.my-collapse {
  border: 1px solid #ebeef5;
  margin-bottom: 40px;
  padding-left: 20px;
}
.my-collapse-title {
  i {
    font-size: 16px;
    margin-right: 10px;
    color: #999;
  }
  .el-collapse-item {
    border-left: solid 1px #ebeef5;
    border-right: solid 1px #ebeef5;
    padding: 0 20px;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
}
</style>
<template>
  <el-collapse class="my-collapse sizing">
    <el-collapse-item name="1">
      <template #title>
        <div class="my-collapse-title">
          <i class="el-icon-info"></i>條件篩選
        </div>
      </template>
      <el-form
        size="small"
        :inline="true"
        :ref="(el) => (state.formInline = el)"
        label-width="100px"
        :model="state.form"
        class="demo-form-inline"
      >
        <el-form-item label="搜索" prop="multi">
          <el-input
            placeholder="電話/郵箱/用戶名"
            v-model="state.form.seatch_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="狀態" prop="status">
          <el-select placeholder="請選擇" v-model="state.form.region">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="screen-btnaction">
          <el-button type="primary" @click="seach">查詢</el-button>
          <el-button @click="resetValue">重置</el-button>
        </el-form-item>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { reactive } from "vue";

export default {
  setup(props, { emit }) {
    const state = reactive({
      formInline: "",
      form: {
        seatch_name: "", // 搜索inpuit框輸入的值
        region: "", // 下拉框選擇的值
      },
    });

    const resetValue = () => {
      // 重置
      state.form = {
        seatch_name: "",
        region: "",
      };
    };

    const seach = () => {
      emit("seach", state.form);
    };

    return {
      state,
      resetValue,
      seach,
    };
  },
};
</script>
